import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Dropdown, Menu } from 'antd';
import ArrowDownIcon from '@/assets/mo/ArrowDown.svg?react';
import About from './About';
import type { MenuInfo } from 'rc-menu/lib/interface';

const introTabs = [
  { key: 'news', label: '최신소식' },
  { key: 'faq', label: '자주묻는질문' },
  { key: 'about', label: '올받음소개' },
  { key: 'adjusters', label: '손사소개' },
];

const defaultDescriptions: Record<string, string> = {
  news: '언론보도와 공지사항을 확인해보세요!',
  faq: '무엇이든 물어보세요. 빠르게 답변드릴게요!',
  about: '올받음이 소비자 편에서 도와드리겠습니다',
  adjusters: '올받음 손해사정사를 소개합니다',
};

const LatestNewsLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentKey = location.pathname.split('/')[2] || 'About'; // ✅ 쿼리스트링 제거된 정확한 path
  console.log('[🔍 currentKey]', currentKey);
  const currentLabel = introTabs.find((tab) => tab.key === currentKey)?.label || '';
  const currentDesc = defaultDescriptions[currentKey];

  const handleTabChange = (e: MenuInfo) => {
    navigate(`/intro/${e.key}`);
  };

  return (
    <Wrapper>
      <TabHeader>
        <Dropdown
          overlay={<Menu items={introTabs} onClick={handleTabChange} />}
          trigger={['click']}
        >
          <DropdownButton>
            <TitleText>{currentLabel}</TitleText>
            <ArrowDownIcon />
          </DropdownButton>
        </Dropdown>
        <Description>{currentDesc}</Description>
      </TabHeader>

      <IntroContainer>
        {currentKey !== 'about' ? (
          <NoResultText>{`${currentKey} 페이지 준비 중입니다.`}</NoResultText>
        ) : (
          <About />
        )}
      </IntroContainer>
    </Wrapper>
  );
};

export default LatestNewsLayout;

// ✅ styled-components

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  padding-top: 106px;
`;

const TabHeader = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DropdownButton = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 32px;
  font-weight: 700;
`;

const TitleText = styled.span``;

const Description = styled.div`
  font-size: 18px;
  font-weight: 400;
  text-align: start;
`;

const IntroContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 16px;
`;

const NoResultText = styled.div`
  width: 100%;
  text-align: center;
  padding: 32px 0;
  color: var(--gray-ui_gray04, #6f6f6f);
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.32px;
`;
